import { UserSessionWidgetComponent } from '../User/UserSessionWidgetComponent';

export const TopBarComponent = () => {
  return (
    <div className="topBar">
      {/* El logo se mudo del menu lateral al header: ahi ocupaba 180px de alto
          fijo en una barra que ahora se contrae, y esa altura no se podia
          recuperar para los items. */}
      <img
        className="topBarLogo"
        src={require('../../assets/img/logo_alphacr.png')}
        alt="Ichtys"
      />
      <UserSessionWidgetComponent />
    </div>
  );
};
